import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
const antes = ['Improvisar.', 'Repetir ejercicios.', 'Buscar ideas cinco minutos antes.', 'Explicar demasiado.', 'No saber qué toca después.', 'Sentir que simplemente estás tirando bolas.'];
const conSistema = ['Planificar.', 'Seguir progresiones.', 'Corregir con prioridades.', 'Organizar grupos.', 'Dar continuidad.', 'Dirigir una clase con intención.'];
export function TransformationSection() {
  return <section className="bg-mp-black py-20 md:py-28" data-id="element-338" data-mp="2e6mmrytf8xck">
      <Container data-id="element-339" data-mp="2e51s8973xeep">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6" data-id="element-340" data-mp="2982znv33dfim">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut
        }} className="rounded-2xl border border-mp-border bg-mp-dark p-7 md:p-9" data-id="element-341" data-mp="299w6badpfzqm">
            <p className="font-heading text-xs uppercase tracking-[0.2em] text-mp-gray" data-id="element-342" data-mp="f99dtu9rrf78">Antes</p>
            <ul className="mt-5 space-y-3" data-id="element-343" data-mp="k3lzmaypx2m5">
              {antes.map(line => <li key={line} className="text-base text-mp-gray/80 md:text-lg" data-id="element-344" data-mp="5atjlifg3pti">
                  {line}
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: 0.05
        }} className="rounded-2xl border border-mp-lime/40 bg-mp-card p-7 shadow-glow-lime md:p-9" data-id="element-345" data-mp="y23f5legz8sz">
            <p className="font-heading text-xs uppercase tracking-[0.2em] text-mp-lime" data-id="element-346" data-mp="39rcvz4h78fo7">Con un sistema</p>
            <ul className="mt-5 space-y-3" data-id="element-347" data-mp="3dt7tryzx8ax8">
              {conSistema.map(line => <li key={line} className="text-base font-medium text-mp-white md:text-lg" data-id="element-348" data-mp="1k9pnmkhd16gr">
                  {line}
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        ease: easeOut
      }} className="mt-14 text-center" data-id="element-349" data-mp="1ajnzjsp0bo1u">
          <p className="font-heading text-2xl uppercase leading-tight text-mp-white sm:text-3xl md:text-4xl" data-id="element-350" data-mp="11hesxdwv0etq">
            De <span className="text-mp-gray" data-id="element-351" data-mp="rlbr695x6i7b">"tirabolas"</span> a monitor con{' '}
            <span className="text-mp-lime" data-id="element-352" data-mp="rneeglfotx8c">método</span>.
          </p>
          <div className="mx-auto mt-6 max-w-[650px] space-y-2 text-sm leading-relaxed text-mp-gray md:text-base" data-id="element-353" data-mp="mniin9h59c3v">
            <p data-id="element-354" data-mp="2lyjoq8la57wn">No porque un manual vaya a hacer el trabajo por ti.</p>
            <p data-id="element-355" data-mp="2h1b6k804t3ve">
              Sino porque trabajar con una estructura te permite dedicar menos energía a decidir qué hacer y más a
              enseñar.
            </p>
          </div>
        </motion.div>
      </Container>
    </section>;
}